import React from 'react';
import { extraServicesAvailable } from '../../../../utils/contractManagement';
import { deliveryIsGreen } from '../../ContractDetails';

import { ManageContractsApp } from '../contractManagementContext';
import ExtraServices from '../sections/ExtraServices';
import HouseType from '../sections/HouseType';

export const ChangeServices: React.FunctionComponent = () => {
  const [oldContractExtraServicesAvailable, setOldContractExtraServicesAvailable] = React.useState<boolean>(false);

  const { filteredContracts, oldContract, houseType } = ManageContractsApp.useState();

  React.useEffect(() => {
    const old = oldContract;

    /* To be enabled in LE-262 / CD-669
    if(old && (old.activeDeliveries && existingExtraServices(old.activeDeliveries).length > 0)) {
      setOldContractHasExtraServices(true);
    }
    else {
      setOldContractHasExtraServices(false);
    }
    */
    if (old && old.activeDeliveries && extraServicesAvailable(old.activeDeliveries)) {
      setOldContractExtraServicesAvailable(true);
    } else {
      setOldContractExtraServicesAvailable(false);
    }
  }, [oldContract, filteredContracts, oldContract]);

  // Only show extra services if contract doesn't already have green energy extra service

  return (
    <>
      {oldContract && !oldContract?.activeDeliveries?.find((d) => deliveryIsGreen(d)) && (
        <>
          {oldContractExtraServicesAvailable && <HouseType />}
          {houseType &&
            oldContract.activeDeliveries &&
            extraServicesAvailable(oldContract?.activeDeliveries) &&
            !oldContract?.activeDeliveries?.find((d) => deliveryIsGreen(d)) && <ExtraServices />}
        </>
      )}
    </>
  );
};

export default ChangeServices;
